<template>
    <v-dialog v-model="dialog" :persistent="salvando" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 2">
                <v-btn icon dark :disabled="salvando" @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>{{ item.id ? 'Captação' : 'Nova Captação' }}</v-toolbar-title>
                <v-spacer/>
                <v-toolbar-items><v-btn dark text :loading="salvando" :disabled="!valid" @click="save">Salvar</v-btn></v-toolbar-items>
                <template v-slot:extension>
                    <v-tabs v-model="aba" show-arrows>
                        <v-tab>Geral</v-tab><v-tab>Contatos</v-tab><v-tab :disabled="!item.id">Atividades</v-tab><v-tab :disabled="!item.id">Histórico</v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>
            <v-card-text class="mt-3">
                <v-alert v-if="erro" type="error" text>{{ erro }}</v-alert>
                <v-form ref="formCadastroOportunidade" v-model="valid" lazy-validation>
                    <v-tabs-items v-model="aba">
                        <v-tab-item eager>
                            <v-row>
                                <v-col cols="12" md="1"><v-text-field v-model="item.id" label="Código" readonly outlined dense/></v-col>
                                <v-col cols="12" md="6">
                                    <v-autocomplete v-if="!item.id" v-model="item.doadorId" :items="doadores" :loading="isLoading" :search-input.sync="searchDoador" hide-no-data cache-items item-text="nome" item-value="id" label="Doador" placeholder="Digite um doador" :rules="fieldRules" outlined dense/>
                                    <v-text-field v-else :value="item.doador ? item.doador.nome : ''" label="Doador" readonly outlined dense/>
                                </v-col>
                                <v-col cols="12" md="5"><v-text-field v-model="item.descricao" label="Descrição" :rules="fieldRules" counter="80" maxlength="80" outlined dense/></v-col>
                                <v-col cols="12" md="4"><v-text-field v-model="item.valorTotal" label="Valor" outlined dense/></v-col>
                                <v-col cols="12" md="4"><v-select v-model="item.probabilidade" :items="probabilidades" item-text="nome" item-value="id" label="Probabilidade" :rules="fieldRules" outlined dense/></v-col>
                                <v-col cols="12" md="4"><v-select v-model="item.fonte" :items="fontes" item-text="value" item-value="key" label="Fonte" outlined dense/></v-col>
                                <v-col cols="12" md="4"><v-select v-model="item.status" :items="status" item-text="value" item-value="key" label="Status" outlined dense/></v-col>
                                <v-col cols="12" md="4"><v-select v-model="item.leiIncentivo" :items="leiIncentivos" item-text="value" item-value="key" label="Lei Incentivo" outlined dense/></v-col>
                                <v-col cols="12" md="4"><v-autocomplete v-model="item.responsavelId" :items="responsaveis" item-text="nome" item-value="id" label="Responsável" clearable outlined dense/></v-col>
                                <v-col cols="12" md="6"><v-autocomplete v-model="item.contatoPrincipalId" :items="contatos" :loading="carregandoContatos" item-text="nome" item-value="id" label="Contato principal" :disabled="!item.doadorId" clearable outlined dense/></v-col>
                                <v-col cols="12" md="6"><v-text-field v-model="item.previsaoFechamento" type="date" label="Previsão de fechamento" clearable outlined dense/></v-col>
                                <v-col cols="12" md="8">
                                    <div v-if="item.anexo" class="d-flex align-center flex-wrap">
                                        <v-chip color="primary" class="mr-2" @click="DownloadDocumento">{{ item.anexo }}</v-chip>
                                        <v-btn text color="error" :disabled="salvando" @click="DeletarDocumento"><v-icon left>mdi-delete</v-icon>Excluir documento</v-btn>
                                    </div>
                                    <v-file-input v-else v-model="arquivoCarregar" accept=".pdf" show-size label="Anexo PDF" outlined dense/>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                        <v-tab-item>
                            <v-alert v-if="!item.doadorId" type="info" text>Selecione o doador na aba Geral para consultar seus contatos.</v-alert>
                            <v-data-table v-else :headers="headerContato" :items="contatos" :loading="carregandoContatos" :items-per-page="-1" hide-default-footer no-data-text="Nenhum contato vinculado ao doador.">
                                <template v-slot:[`item.principal`]="{ item: contato }"><v-btn text small :color="item.contatoPrincipalId === contato.id ? 'primary' : undefined" @click="item.contatoPrincipalId = contato.id"><v-icon small left>{{ item.contatoPrincipalId === contato.id ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>{{ item.contatoPrincipalId === contato.id ? 'Principal' : 'Selecionar' }}</v-btn></template>
                            </v-data-table>
                        </v-tab-item>
                        <v-tab-item><atividades v-if="dialog && item.id && aba === 2" :key="item.id" :oportunidade-id="item.id" @atualizado="AtividadeAtualizada"/></v-tab-item>
                        <v-tab-item><historico v-if="dialog && item.id && aba === 3" :key="item.id" :oportunidade-id="item.id" @atualizado="AtividadeAtualizada"/></v-tab-item>
                    </v-tabs-items>
                </v-form>
            </v-card-text>
        </v-card>
        <v-overlay :value="salvando"><v-progress-circular indeterminate size="64"/></v-overlay>
    </v-dialog>
</template>
<script>
import OportunidadeService from '../../../core/services/doacao/OportunidadeService';
import DoadorService from '../../../core/services/doacao/DoadorService';
import Oportunidade from '../../../core/domain/doacao/Oportunidade';
import OportunidadeFonteEnumService from '../../../core/services/doacao/OportunidadeFonteEnumService';
import OportunidadeStatusEnumService from '../../../core/services/doacao/OportunidadeStatusEnumService';
import OportunidadeLeiIncentivoEnumService from '../../../core/services/doacao/OportunidadeLeiIncentivoEnumService';
import Atividades from './Atividades.vue';
import Historico from './Historico.vue';

export default {
    components: { Atividades, Historico },
    props: { item: { required: true }, value: {} },
    data: () => ({
        service: new OportunidadeService(), doadorService: new DoadorService(),
        valid: true, dialog: false, aba: 0, isLoading: false, salvando: false, carregandoContatos: false,
        searchDoador: null, doadores: [], contatos: [], responsaveis: [], fontes: [], status: [], leiIncentivos: [],
        arquivoCarregar: null, erro: '', buscaDoador: 0, requisicaoContato: 0,
        fieldRules: [v => !!v || 'Campo obrigatório'],
        probabilidades: [{ id: 1, nome: 'Prospecção 0%' }, { id: 2, nome: 'Participação em edital 20%' }, { id: 3, nome: 'Reunião agendada 40%' }, { id: 4, nome: 'Revisão do projeto 60%' }, { id: 5, nome: 'Negociação 80%' }, { id: 6, nome: 'Fechamento 100%' }],
        headerContato: [{ text: 'Contato principal', value: 'principal', sortable: false }, { text: 'Nome', value: 'nome' }, { text: 'Cargo', value: 'cargo' }, { text: 'Telefone', value: 'telefone' }, { text: 'Ramal', value: 'ramal' }, { text: 'Celular', value: 'celular' }, { text: 'E-mail', value: 'email' }]
    }),
    watch: {
        item() { if (this.dialog) this.Preparar(); },
        value: { immediate: true, handler(valor) { this.dialog = !!valor; } },
        dialog(valor) { if (valor) this.Preparar(); else { this.requisicaoContato++; this.buscaDoador++; this.$emit('fechou'); } },
        'item.doadorId'(valor, anterior) {
            if (!this.dialog) return;
            if (!this.item.id && anterior && valor !== anterior) this.$set(this.item, 'contatoPrincipalId', null);
            this.CarregarContatos(valor);
        },
        async searchDoador(valor) {
            const requisicao = ++this.buscaDoador;
            if (!valor) { this.isLoading = false; return; }
            this.isLoading = true;
            try { const res = await this.doadorService.AutoComplete(valor); if (requisicao === this.buscaDoador) this.doadores = res.data || []; }
            catch (err) { if (requisicao === this.buscaDoador) this.erro = this.Mensagem(err); }
            finally { if (requisicao === this.buscaDoador) this.isLoading = false; }
        }
    },
    created() { if (this.dialog) this.Preparar(); },
    beforeDestroy() { this.requisicaoContato++; this.buscaDoador++; },
    methods: {
        Preparar() {
            this.aba = 0;
            this.erro = '';
            this.arquivoCarregar = null;
            this.searchDoador = null;
            this.doadores = this.item.doador ? [this.item.doador] : [];
            this.$set(this.item, 'previsaoFechamento', this.item.previsaoFechamento ? this.item.previsaoFechamento.slice(0, 10) : null);
            this.CarregarContatos(this.item.doadorId);
            this.$nextTick(() => { if (this.$refs.formCadastroOportunidade) this.$refs.formCadastroOportunidade.resetValidation(); });
            Promise.all([this.service.Responsaveis(), new OportunidadeFonteEnumService().Listar(), new OportunidadeStatusEnumService().Listar(), new OportunidadeLeiIncentivoEnumService().Listar()]).then(res => {
                this.responsaveis = res[0].data || [];
                this.fontes = res[1].data || [];
                this.status = res[2].data || [];
                this.leiIncentivos = res[3].data || [];
            }).catch(err => { this.erro = this.Mensagem(err); });
        },
        async CarregarContatos(doadorId) {
            const requisicao = ++this.requisicaoContato;
            this.contatos = [];
            this.carregandoContatos = false;
            if (!doadorId) return;
            if (this.item.doador && this.item.doador.id === doadorId && Array.isArray(this.item.doador.contatos)) { this.contatos = this.item.doador.contatos; return; }
            this.carregandoContatos = true;
            try {
                const res = await this.doadorService.ObterPorId(doadorId, 'Contatos');
                if (requisicao === this.requisicaoContato && this.item.doadorId === doadorId) {
                    this.contatos = res.data.contatos || [];
                    this.$set(this.item, 'doador', res.data);
                }
            } catch (err) { if (requisicao === this.requisicaoContato) this.erro = this.Mensagem(err); }
            finally { if (requisicao === this.requisicaoContato) this.carregandoContatos = false; }
        },
        async save() {
            if (this.salvando) return;
            if (!this.$refs.formCadastroOportunidade.validate()) { this.aba = 0; return; }
            const registro = this.item;
            let id = registro.id;
            const arquivoCarregar = this.arquivoCarregar;
            const doador = registro.doador || this.doadores.find(x => x.id === registro.doadorId);
            const contextoAtual = () => this.dialog && this.item === registro && registro.id === id;
            this.salvando = true;
            this.erro = '';
            try {
                const modelo = new Oportunidade(registro);
                modelo.previsaoFechamento = modelo.previsaoFechamento || null;
                modelo.responsavelId = modelo.responsavelId || null;
                modelo.contatoPrincipalId = modelo.contatoPrincipalId || null;
                const res = await this.service.Salvar(modelo);
                if (!contextoAtual()) return;
                const salvo = res.data;
                const idSalvo = salvo && salvo.id ? salvo.id : id;
                if (!registro.id && idSalvo) this.$set(registro, 'id', idSalvo);
                id = idSalvo;
                if (doador && !registro.doador) this.$set(registro, 'doador', doador);
                if (!salvo || typeof salvo.versao !== 'number') throw new Error('A captação foi salva. Reabra o cadastro para continuar.');
                this.$set(registro, 'versao', salvo.versao);
                if (typeof salvo.empresaId === 'number') this.$set(registro, 'empresaId', salvo.empresaId);
                if (arquivoCarregar) {
                    const versao = salvo.versao;
                    const arquivo = await this.Ler(arquivoCarregar);
                    if (!contextoAtual()) return;
                    const documento = await this.service.EnviarDocumento(id, arquivoCarregar.name, arquivo, versao);
                    if (!contextoAtual()) return;
                    this.$set(registro, 'versao', documento.data.versao);
                    this.$set(registro, 'anexo', documento.data.anexo);
                    this.arquivoCarregar = null;
                }
                this.$emit('salvou');
                this.close();
            } catch (err) { if (contextoAtual()) this.erro = this.Mensagem(err); }
            finally { this.salvando = false; }
        },
        async DeletarDocumento() {
            if (this.salvando) return;
            const registro = this.item;
            const id = registro.id;
            const anexo = registro.anexo;
            const versao = registro.versao;
            const contextoAtual = () => this.dialog && this.item === registro && registro.id === id;
            const confirmacao = await this.$swal({ title: 'Atenção!', text: 'Tem certeza que deseja excluir o documento atual?', type: 'question', showCancelButton: true, confirmButtonText: 'Sim', cancelButtonText: 'Não' });
            if (!confirmacao.value || !contextoAtual() || registro.versao !== versao || registro.anexo !== anexo) return;
            this.salvando = true;
            try {
                const res = await this.service.DeletarDocumento(id, anexo, versao);
                if (!contextoAtual()) return;
                this.$set(registro, 'anexo', res.data.anexo);
                this.$set(registro, 'versao', res.data.versao);
                this.$emit('atualizado');
            }
            catch (err) { if (contextoAtual()) this.erro = this.Mensagem(err); }
            finally { this.salvando = false; }
        },
        async DownloadDocumento() { try { await this.service.DownloadDocumento(this.item.id, this.item.anexo); } catch (err) { this.erro = this.Mensagem(err); } },
        Ler(arquivo) { return new Promise((resolve, reject) => { const leitor = new FileReader(); leitor.onload = evento => resolve(evento.target.result); leitor.onerror = () => reject(new Error('Não foi possível ler o arquivo.')); leitor.readAsArrayBuffer(arquivo); }); },
        AtividadeAtualizada() { this.$emit('atualizado'); },
        close() { this.dialog = false; },
        Mensagem(err) { const data = err.response && err.response.data; return typeof data === 'string' ? data : (data && (data.detail || data.title)) || err.message || 'Não foi possível concluir a operação.'; }
    }
};
</script>
